import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/shared/customer/customer.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    standalone: false
})
export class SignInComponent implements OnInit {
  userDetails
  slideIndex = 0;

  constructor(public loginService: LoginService, private router : Router, private customerSevice: CustomerService) { }
  serverErrorMessages: string;
  loading: boolean = true
  signInForm = new FormGroup({
    userName: new FormControl('',
    [Validators.required]),
    password: new FormControl('',
    [Validators.required,
    Validators.minLength(8)])
  })

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loading = false;
     //console.log("Yo I am Logged in still");
      this.loginService.getUserProfile().subscribe(
        res => {
          this.userDetails = res['user'];
         //console.log('got logged in user', this.userDetails);
          window.alert('User is already logged in');
          this.router.navigateByUrl('/home');
          this.loading = false;
        },
        err => {
         //console.log('Did not get user', err);
          this.loading = false;
        });
    }
    this.loading = false;



  }

  onSubmitLogin(){
alert();
  }

  onSubmit(){
   //console.log('Inside onsubmit', this.signInForm.value)
      this.loginService.login(this.signInForm.value).subscribe(
        res => {
         //console.log('signed in ', res)
          this.loginService.setToken(res['access_token']);
          this.router.navigateByUrl('/home');
        },
        err => {
         //console.log('Error logging user in', err);
          if(err.status === 503){
            alert('First Login! Please accept our terms and conditions and change your password.');
            this.router.navigateByUrl('/acceptpolicy')
          }
          this.serverErrorMessages = err.error.message;
        });
  }



ngAfterViewInit(): void{
  this.slideIndex = 0;
  this.showSlides();
}


 showSlides() {
  let i;
  let slides = document.getElementsByClassName("mySlides")as HTMLCollectionOf<HTMLElement>;
  let dots = document.getElementsByClassName("dot");
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  this.slideIndex++;
  if (this.slideIndex > slides.length) {this.slideIndex = 1}
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[this.slideIndex-1].style.display = "block";
  dots[this.slideIndex-1].className += " active";
  setTimeout(()=>{
    this.showSlides();
}, 2000); // Change image
}












}
